import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export const useTranslationLabel = () => {
  const { t } = useTranslation(["translation"])

  return useMemo(() => {
    return {
      LOGIN_TITLE: t("login_title"),
      DISCONNECT_DRIVER: t("disconnect_driver"),
      DISCONNECT_DRIVER_MODAL_TITLE: t("disconnect_driver_modal_title"),
      DISCONNECT_DRIVER_MODAL_DESCRIPTION: t("disconnect_driver_modal_description"),
      DISCONNECT_DRIVER_MODAL_BTN: t("disconnect_driver_modal_btn"),
      DISCONNECT_DRIVER_MODAL_SUB_BTN: t("disconnect_driver_modal_sub_btn"),
      SEARCH: t("search"),
      LOGIN: t("login"),
      LOGIN_VERIFY_CODE: t("login_verify_code"),
      LOGIN_ERROR: t("login_error"),
      REMEMBER_ME: t("remember_me"),
      FORGOT_PASSWORD: t("forgot_password"),
      HEADER_MY_PROFILE: t("header_my_profile"),
      HEADER_NEW_RESERVATION: t("header_new_reservation"),
      HEADER_MONTHLY_SUMMARY: t("header_monthly_summary"),
      HEADER_MY_RIDES: t("header_my_rides"),
      USER_TYPE_PRIVATE: t("user_type_private"),
      USER_TYPE_BUSINESS: t("user_type_business"),
      USER_DETAILS_TITLE: t("user_details_title"),
      USER_DETAILS_EDIT_BTN: t("user_details_edit_btn"),
      USER_DETAILS_SAVE_BTN: t("user_details_save_btn"),
      USER_DETAILS_UPDATE_PASSWORD: t("user_details_update_password"),
      USER_DETAILS_UPDATE_PINCODE: t("user_details_update_pincode"),

      GENERAL_DETAILS_TITLE: t("general_details_title"),
      GENERAL_TOGGLE_1: t("general_toggle_1"),
      GENERAL_TOGGLE_2: t("general_toggle_2"),
      GENERAL_TOGGLE_3: t("general_toggle_3"),

      LOGIN_DETAILS_TITLE: t("login_details_title"),
      LOGIN_DETAILS_EMAIL: t("login_details_email"),
      LOGIN_DETAILS_PASSWORD: t("login_details_password"),
      LOGIN_DETAILS_PIN: t("login_details_pincode"),
      PAYMENT_DETAILS_TITLE: t("payment_details_title"),
      PAYMENT_ADD_CARD_BTN: t("payment_add_card_btn"),
      PAYMENT_TABLE_NUMBER: t("payment_table_number"),
      PAYMENT_TABLE_VALIDITY: t("payment_table_validity"),
      PAYMENT_TABLE_PRIMARY: t("payment_table_primary"),
      PAYMENT_TABLE_ACTIVE: t("payment_table_active"),
      PAYMENT_TABLE_ACTIONS: t("payment_table_actions"),
      REGISTERED_DRIVERS_TITLE: t("registered_drivers_title"),
      RIDES: t("rides"),
      CANCELLATIONS: t("cancellations"),

      RESET_PASSWORD_PAGE_TITLE: t("reset_password_page_title"),

      DRIVER_REGISTRATION_TITLE: t("driver_registration_title"),
      DRIVER_REGISTRATION_DESCRIPTION_1: t("driver_registration_description_1"),
      DRIVER_REGISTRATION_DESCRIPTION_2: t("driver_registration_description_2"),

      DRIVER_REGISTRATION_PREFERENCE_UNDER_23: t(
        "driver_registration_preference_under_23",
      ),
      DRIVER_REGISTRATION_PRIVACY_POLICY_1: t(
        "driver_registration_privacy_policy_1",
      ),
      DRIVER_REGISTRATION_PRIVACY_POLICY_2: t(
        "driver_registration_privacy_policy_2",
      ),
      DRIVER_REGISTRATION_TERMS_AND_CONDITIONS_1: t(
        "driver_registration_terms_and_conditions_1",
      ),
      DRIVER_REGISTRATION_TERMS_AND_CONDITIONS_2: t(
        "driver_registration_terms_and_conditions_2",
      ),
      DRIVER_REGISTRATION_SPECIAL_OFFERS_1: t(
        "driver_registration_special_offers_1",
      ),
      DRIVER_REGISTRATION_SPECIAL_OFFERS_2: t(
        "driver_registration_special_offers_2",
      ),

      DRIVER_REGISTRATION_SUCCESS_DESCRIPTION_1: t(
        "driver_registration_success_description_1",
      ),
      DRIVER_REGISTRATION_SUCCESS_DESCRIPTION_2: t(
        "driver_registration_success_description_2",
      ),

      DRIVER_LICENSE_FRONT_INPUT_TITLE: t("driver_license_front_input_title"),
      DRIVER_LICENSE_BACK_INPUT_TITLE: t("driver_license_back_input_title"),
      ID_OR_PASSPORT_FRONT_INPUT_TITLE: t("id_or_passport_front_input_title"),
      DRIVER_LICENSE_SELFIE_INPUT_TITLE: t("driver_license_selfie_input_title"),

      DRIVER_REGISTRATION_23_DISCLAIMER: t("driver_registration_23_disclaimer"),

      SHOW_MORE: t("show_more"),

      ADD_DRIVER: t("add_driver"),
      ADD_A_DRIVER: t("add_a_driver"),
      ADD_A_DRIVER_DETAILS_MODAL_DESCRIPTION: t(
        "add_a_driver_details_modal_description",
      ),
      ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_1: t(
        "add_a_driver_details_success_modal_description_1",
      ),
      ADD_A_DRIVER_DETAILS_SUCCESS_MODAL_DESCRIPTION_2: t(
        "add_a_driver_details_success_modal_description_2",
      ),

      ADD_A_DRIVER_MODAL_DESCRIPTIN1: t("add_a_driver_modal_description1"),
      ADD_A_DRIVER_MODAL_DESCRIPTIN2: t("add_a_driver_modal_description2"),

      DOWNLOAD_APP: t("download_app"),
      SPAIN: t("spain"),
      TERMS_AND_CONDITIONS: t("terms_and_conditions"),
      TERMS_AN_CONDITIONS: t("terms_&_conditions"),
      PRIVACY_POLICY: t("privacy_policy"),
      FAQ: t("faq"),
      CONTACT_US: t("contact_us"),

      CHANGE_PASSWORD_MODAL_TITLE: t("change_password_modal_title"),
      CHANGE_PASSWORD_MODAL_DESCRIPTION: t("change_password_modal_description"),

      FORGOT_PASSWORD_MODAL_TITLE: t("forgot_password_modal_title"),
      FORGOT_PASSWORD_MODAL_DESCRIPTION: t("forgot_password_modal_description"),
      FORGOT_PASSWORD_SUCCESS_MODAL_TITLE: t(
        "forgot_password_success_modal_title",
      ),
      FORGOT_PASSWORD_SUCCESS_MODAL_DESCRIPTION_1: t(
        "forgot_password_success_modal_description_1",
      ),
      FORGOT_PASSWORD_SUCCESS_MODAL_DESCRIPTION_2: t(
        "forgot_password_success_modal_description_2",
      ),

      VERIFY_PHONE_MODAL_TITLE: t("verify_phone_modal_title"),
      VERIFY_PHONE_MODAL_DESCRIPTION: t("verify_phone_modal_description"),
      VERIFY_PHONE_MODAL_DIDNT_GET_CODE: t("verify_phone_modal_didnt_get_code"),
      VERIFY_PHONE_MODAL_RESEND: t("verify_phone_modal_resend"),

      CHANGE_PINCODE_MODAL_TITLE: t("change_pincode_modal_title"),

      ADD_CARD_MODAL_TITLE: t("add_credit_card_modal_title"),
      HOLDER_NAME: t("holder_name"),
      CARD_NUMBER: t("card_number"),
      DATE_OF_EXPIRY: t("date_of_expiry"),
      CVV: t("cvv"),
      BTN_ADD_CARD: t("btn_add_card"),

      EMAIL_ALREADY_EXISTS: t("email_already_exists"),

      SIMPLE_MODAL_ERROR_TITLE: t("simple_modal_error_title"),
      SIMPLE_MODAL_ERROR_DESCRIPTION: t("simple_modal_error_description"),
      SIMPLE_MODAL_SUCCESS_TITLE: t("simple_modal_success_title"),
      CHANGE_PASSWORD_MODAL_SUCCESS_DESCRIPTION: t(
        "change_password_modal_success_description",
      ),
      INPUT_EMAIL: t("input_email"),
      INPUT_PHONE_NUMBER: t("input_phone_number"),
      INPUT_COUNTRY: t("input_country"),
      INPUT_PASSWORD: t("input_password"),
      INPUT_CURRENT_PASSWORD: t("input_current_password"),
      INPUT_NEW_PASSWORD: t("input_new_password"),
      INPUT_CONFIRM_PASSWORD: t("input_confirm_password"),
      INPUT_CONFIRM_NEW_PASSWORD: t("input_confirm_new_password"),
      INPUT_NEW_PASSWORD_CONFIRM: t("input_new_password_confirm"),

      INPUT_PINCODE: t("input_pincode"),
      INPUT_CURRENT_PINCODE: t("input_current_pincode"),
      INPUT_NEW_PINCODE: t("input_new_pincode"),
      INPUT_CONFIRM_NEW_PINCODE: t("input_confirm_new_pincode"),

      INPUT_FIRST_NAME: t("input_first_name"),
      INPUT_LAST_NAME: t("input_last_name"),

      INPUT_STREET_AND_HOUSE_NUM: t("input_street_and_house_num"),
      INPUT_CITY: t("input_city"),
      INPUT_POSTAL_CODE: t("input_postal_code"),
      INPUT_PHONE: t("input_phone"),

      INPUT_PASSWORD_HINT: t("input_password_hint"),
      INPUT_PASSWORD_HINT2: t("input_password_hint2"),
      INPUT_FIRST_NAME_REQUIRED: t("input_first_name_required"),
      INPUT_LAST_NAME_REQUIRED: t("input_last_name_required"),

      BTN_CONFIRM: t("btn_confirm"),
      BTN_CONTINUE: t("btn_continue"),
      BTN_APPROVE: t("btn_approve"),
      BTN_SUBMIT: t("btn_submit"),
      BTN_CANCEL: t("btn_cancel"),

      LOGOUT: t("logout"),

      ENTER_VALID_EMAIL: t("enter_valid_email"),
      PASSWORD_REQUIRED: t("password_required"),
      WRONG_FORMAT: t("wrong_format"),
      INCORRECT_PASSWORD: t("incorrect_password"),
      PHONE_MIN: t("phone_min"),
      PHONE_MAX: t("phone_max"),
      STREET_REQUIRED: t("street_required"),
      CITY_REQUIRED: t("city_required"),
      POSTAL_CODE_REQUIRED: t("postal_code_required"),
      CURRENT_PASSWORD_REQUIRED: t("current_password_required"),
      PASSWORD_INCLUDE_LOWERCASE: t("password_include_lowercase"),
      PASSWORD_INCLUDE_NUMBER: t("password_include_number"),
      PASSWORD_AT_LEAST: t("password_at_least"),
      CHARACTERS_LONG: t("characters_long"),
      PASSWORDS_NOT_MATCH: t("passwords_not_match"),
      PIN_NOT_MATCH: t("pin_not_match"),
      INVALID_POSTAL_CODE: t("invalid_postal_code"),
      IMAGES_REQUIRED: t("images_required"),
      POSTAL_CODE_MIN: t("postal_code_min"),
      POSTAL_CODE_MAX: t("postal_code_max"),
      PIN_CODE_DIGITS: t("pin_code_digits"),
      AGREE_PRIVACY_POLICY: t("agree_privacy_policy"),
      AGREE_TERMS: t("agree_terms"),

      INPUT_START_DATE: t("input_start_date"),
      INPUT_END_DATE: t("input_end_date"),
      INPUT_START_HOUR: t("input_start_hour"),
      INPUT_END_HOUR: t("input_end_hour"),

      ERROR_MODAL_TITLE: t("error_modal_title"),
      ERROR_MODAL_DESCRIPTION: t("error_modal_description"),

      ALL_CATEGORIES: t("all_categories"),
      REQ_SUCCESS: t("req_success"),
      REQ_FAILD: t("req_faild"),

      SET_AS_PRIMARY: t("set_as_primary"),
      DEACTIVATE: t("deactivate"),
      ACTIVATE: t("activate"),

      SELECT_DRIVER: t("select_driver"),
      BOOKED_RESERVATIONS: t("booked_reservations"),
      PAST_RESERVATIONS: t("past_reservations"),

      FIREST_NAME: t("first_name"),
      LAST_NAME: t("last_name"),
      PHONE_NUMBER: t("phone_number"),

      WRONG_PINCODE: t("wrong_pincode"),

    } as const
  }, [t])
}
